import React from "react";
import { Link } from "react-router-dom";
import { useTranslate } from "../../../../components/TranslationText";
import { HorseGender } from '../../shared/utils/ServicesConstants';
import { LeaseFieldNames } from '../utils/HorseLeasingConstants';
import { TranslationKeys } from '../../../../constants/TranslationKeys';
import { useFormContext, useWatch } from "react-hook-form";
import EahsForm from "../../../../components/EahsForm";
import FormYesNo from "../../../../components/FormInputs/FormYesNo";
import FormTextInput from "../../../../components/FormInputs/FormTextInput";

const HorseLeasingCoveringSection = ({
    isReadOnly,
    onMareCoveredChange
}) => {
    const { translate } = useTranslate();
    const { control } = useFormContext();
    const horseGender = useWatch({ control, name: LeaseFieldNames.HORSE_GENDER });
    const isMareCovered = useWatch({ control, name: LeaseFieldNames.IS_MARE_COVERED });

    if (horseGender !== HorseGender.MARE) return null;

    return (
        <EahsForm isSectionTitle ish3 className={'mb-main'} title={translate(TranslationKeys.COVERING_CERTIFICATE_DETAILS, "Covering Certificate Details")}>
            <div className="row">
                <FormYesNo
                    name={LeaseFieldNames.IS_MARE_COVERED}
                    label={translate("web.isSheFoalOwnerTTransfer", "If this transferred horse is a mare, is she in foal? If yes, covering certificate must be attached")}
                    disabled={isReadOnly}
                    required
                />
            </div>

            {isMareCovered && (
                <>
                    <div className="row">
                        <div className="col-md-6 mb-2">
                            <FormTextInput
                                label={translate("web.coveringCertificateNo", "Covering Certificate No")}
                                name={LeaseFieldNames.COVERING_CERT_NO}
                                disabled
                                required
                            />
                        </div>
                        <div className="col-md-6">
                            <FormTextInput
                                label={translate(TranslationKeys.STALLION, "Stallion")}
                                name={LeaseFieldNames.STALLION_NAME}
                                disabled
                                required
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <FormTextInput
                                label={translate("web.coveringDate", "Covering Date")}
                                name={LeaseFieldNames.COVERING_DATE}
                                disabled
                                required
                            />
                        </div>
                    </div>
                    <div className="col-12 rtl">
                        <Link
                            target="_blank"
                            to={`/requestCoveringCertificate?serviceId=25341E00-BC23-49D7-99BD-61C9F976E73A`}
                            className="red text-start"
                        >
                            {translate("web.noValidCovCer", "Please double check the details of the covering certificate details or click here to register new one")}
                        </Link>
                    </div>
                </>
            )}
        </EahsForm>
    );
};

export default HorseLeasingCoveringSection;
